import AppConstants from '../config/app.constants';

let CashDeliveriesService = function ($http, $q) {

    let cashDeliveries = (searchText, fromLocationId, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, customerId,
                          filterByDeliveryDate, filterByVaultDate) => {
        return $http
            .get(AppConstants.api + `/cash-deliveries/cash-deliveries`, {
                params: {
                    searchText,
                    fromLocationId,
                    branchId,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    sortASC,
                    sortColumn,
                    timezone,
                    customerId,
                    filterByDeliveryDate, 
                    filterByVaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let exportCashDeliveries = (searchText, fromLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId,
                                filterByDeliveryDate, filterByVaultDate) => {
        return $http
            .post(AppConstants.api + `/cash-deliveries/export-cash-deliveries`, {
                searchText,
                fromLocationId,
                branchId,
                startDate,
                endDate,
                sortASC,
                sortColumn,
                timezone,
                customerId,
                filterByDeliveryDate, 
                filterByVaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let cashPickups = (searchText, toLocationId, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, customerId,
                       filterByPickupDate, filterByVaultDate) => {
        return $http
            .get(AppConstants.api + `/cash-deliveries/cash-pickups`, {
                params: {
                    searchText,
                    toLocationId,
                    branchId,
                    startDate,
                    endDate,
                    limit,
                    offset,
                    sortASC,
                    sortColumn,
                    timezone,
                    customerId,
                    filterByPickupDate, 
                    filterByVaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let exportCashPickups = (searchText, toLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId,
                             filterByPickupDate, filterByVaultDate) => {
        return $http
            .post(AppConstants.api + `/cash-deliveries/export-cash-pickups`, {
                searchText,
                toLocationId,
                branchId,
                startDate,
                endDate,
                sortASC,
                sortColumn, 
                timezone,
                customerId,
                filterByPickupDate, 
                filterByVaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let cashPickupLocations = (branchId, startDate, endDate, limit, offset, sortASC, customerId, filterByPickupDate, filterByVaultDate) => {
        return $http
            .get(AppConstants.api + `/cash-deliveries/cash-pickup-locations`, {
                params: {
                    branchId,
                    startDate,
                    endDate,
                    limit,
                    offset,
                    sortASC,
                    customerId,
                    filterByPickupDate, 
                    filterByVaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let cashDeliveryLocations = (branchId, startDate, endDate, limit, offset, sortASC, customerId, filterByDeliveryDate, filterByVaultDate) => {
        return $http
            .get(AppConstants.api + `/cash-deliveries/cash-delivery-locations`, {
                params: {
                    branchId,
                    startDate,
                    endDate,
                    limit,
                    offset,
                    sortASC,
                    customerId,
                    filterByDeliveryDate,
                    filterByVaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportCashTransactions = (searchText, currentStat, fromLocationId, toLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId,
                                  filterByDeliveryDate, filterByPickupDate, filterByVaultDate) => {
        return new Promise(function (resolve, reject) {
            var url = AppConstants.api + `/cash-deliveries/export-cash-transactions`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                searchText, currentStat, fromLocationId, toLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId,
                filterByDeliveryDate, filterByPickupDate, filterByVaultDate
            }

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = 'Cash_Transactions_';
                    var dt = moment(startDate).format('DDMMYY') + '_To_' + moment(endDate).format('DDMMYY');
                    sheetName = reportPrefix.concat(dt, '_', '(', branchId, ')' ,'.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        });
    }

    return {
        cashDeliveries,
        exportCashDeliveries,
        cashPickups,
        exportCashPickups,
        cashPickupLocations,
        cashDeliveryLocations,
        exportCashTransactions
    };
};

CashDeliveriesService.$inject = ['$http', '$q']

export default CashDeliveriesService;


// WEBPACK FOOTER //
// ./client/app/services/cash-deliveries.service.js